export { default as Faq } from './Faq';
export { toFaqProps } from './adapters';
export type { FaqProps } from './Faq';
